import { v4 as uuidv4 } from 'uuid';
import { getTelemetry } from '../../Telemetry/Telemetry';

class LoadingTimeTelemetry {
  private _initTime = 0;
  private _correlationID: string = uuidv4();
  private _components: string[] = [];
  private _comMap: Map<string, boolean> = new Map();

  public start(components: string[]): void {
    if (this._initTime !== 0) {
      return;
    }
    this._initTime = performance.now();
    this._components = [...components];
  }

  public isPageLoaded(): boolean {
    return this._components.length === this._comMap.size;
  }

  public logComponentLoaded = (componentName: string) => {
    if (
      this._comMap.get(componentName) !== undefined ||
      this._components.findIndex((element) => element === componentName) === -1
    ) {
      return;
    }

    this._comMap.set(componentName, true);

    if (this.isPageLoaded()) {
      this.logEvent(`performance/app-mounted/languageSettings`);
    }
  };

  private logEvent = (eventName: string) => {
    const telemetry = getTelemetry();
    telemetry.reportCustomEvent(eventName, {
      time: performance.now() - this._initTime,
      correlationId: this._correlationID,
    });
  };
}

export const PageTelemetry = (() => {
  let instance: LoadingTimeTelemetry;

  function createInstance(): LoadingTimeTelemetry {
    return new LoadingTimeTelemetry();
  }

  return {
    getInstance: () => {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
})();
